export enum RequisitionAction {
    DOWNLOAD = 'download',
    SEND = 'send',
}
